var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrophere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa"
    },
    d: "M401.392,235.528H432c44,0,80,35.936,80,79.872v15.968c0,43.92-36,79.872-80,79.872H80 c-44,0-80-35.936-80-79.872V315.4c0-40.96,31.424-74.592,71.328-78.992C70.544,230.888,70,225.288,70,219.56 c0-65.616,53.28-118.8,118.992-118.8c50.464,0,93.488,31.424,110.8,75.68c0,0,26.672-12.24,60.016-0.448 C401.264,190.664,401.392,235.528,401.392,235.528z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E50914"
    },
    points: "144.272,299.12 180.704,261.968 180.704,351.616 214.688,351.616 214.688,261.968 251.12,299.12 275.384,275.456 197.696,196.256 120.008,275.456 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrophere);
export default __webpack_public_path__ + "static/media/drophere.d29c1714af436c64f55638e16fe03982.svg";
export { ForwardRef as ReactComponent };